import React from 'react';
import { Link } from 'react-router-dom';

const chats = [
	['S', 'bg-secondary bg-opacity-15 text-body', 'Support Team', 'Pricing clarification requested', '2m'],
	['M', 'bg-primary bg-opacity-15 text-primary', 'Marketing', 'Campaign copy needs review', '1h'],
	['D', 'bg-success bg-opacity-15 text-success', 'Design Review', 'Figma components updated', 'Yesterday'],
	['P', 'bg-warning bg-opacity-15 text-warning', 'Product Sync', 'Release timeline confirmed', 'Mon'],
	['A', 'bg-info bg-opacity-15 text-info', 'Admin', 'Access permission granted', 'Sun']
];

function DropdownChat() {
	return (
		<div className="menu-item dropdown d-md-block d-none">
			<a href="#/" data-bs-toggle="dropdown" className="menu-link" aria-label="Open recent chats">
				<iconify-icon icon="solar:chat-dots-bold-duotone"></iconify-icon>
			</a>
			<div className="dropdown-menu dropdown-menu-end w-lg-350px">
				<div className="dropdown-header d-flex justify-content-between align-items-center fs-6 pb-1">
					<div className="fw-bold flex-1">Recent chats</div>
					<a href="#/" className="fw-semibold text-decoration-none small">View all</a>
				</div>
				<div className="dropdown-divider"></div>
				{chats.map(([initial, color, title, description, time]) => (
					<a href="#/" className="dropdown-item py-2" key={title}>
						<div className="d-flex gap-3 align-items-center">
							<div className={`rounded-circle ${color} d-flex align-items-center justify-content-center w-40px h-40px`}>{initial}</div>
							<div className="flex-1">
								<div className="fw-bold">{title}</div>
								<div className="small text-muted fw-semibold">{description}</div>
							</div>
							<div className="small text-body text-opacity-50 fw-semibold">{time}</div>
						</div>
					</a>
				))}
				<div className="dropdown-divider"></div>
				<Link to="/page/messenger-page" className="dropdown-item text-center bg-none small">Open chat history</Link>
			</div>
		</div>
	);
}

export default DropdownChat;
